import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CircularProgress from 'material-ui/CircularProgress'
import {
    VideoContainer,
    ViewportContainer,
    AudioContainer,
    DocumentContainer,
} from '.'
import './media.css'
import NoMedia from './NoMedia/NoMedia.jsx'

export class Media extends Component {
    static propTypes = {
        isViewable: PropTypes.bool.isRequired,
        type: PropTypes.string,
        isSourceLoaded: PropTypes.bool.isRequired,
        frame: PropTypes.object.isRequired,
        id: PropTypes.string.isRequired,
    }

    determineMediaContainer = () => {
        const props = {
            ...this.props,
            mediaRef: this.mediaRef,
        }

        let mediaContainer
        switch(this.props.type)
        {
            case 'image':
                mediaContainer = <ViewportContainer frame={this.props.frame} />
                break
           case 'video':
               mediaContainer = <VideoContainer {...props} />
               break;
           case 'audio':
               mediaContainer = <AudioContainer {...props} />
               break;
           case 'document':
               mediaContainer = <DocumentContainer {...props} />
               break;
            default:
                mediaContainer = null
                break;
        }

        return mediaContainer
    }

    viewableMedia = (mediaContainer) => (
        <div className="media-container print-hidden" ref={(ref) => { this.mediaRef = ref }}>
            {! this.props.isSourceLoaded &&
                <div className="loading-wrapper">
                    <CircularProgress mode="indeterminate" size={80} thickness={5} />
                </div>
            }
            {mediaContainer}
        </div>
    )

    render() {
        let mediaContainer = this.determineMediaContainer()

        let mediaToRender = <NoMedia />
        if(mediaContainer !== null && this.props.isViewable)
        {
            mediaToRender = this.viewableMedia(mediaContainer)
        }

        return mediaToRender
    }
}
